/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClientCompanyWizardStepStateResource = {
    Disabled: 'DISABLED',
    Valid: 'VALID',
    Invalid: 'INVALID'
} as const;
export type ClientCompanyWizardStepStateResource = typeof ClientCompanyWizardStepStateResource[keyof typeof ClientCompanyWizardStepStateResource];


export function instanceOfClientCompanyWizardStepStateResource(value: any): boolean {
    for (const key in ClientCompanyWizardStepStateResource) {
        if (Object.prototype.hasOwnProperty.call(ClientCompanyWizardStepStateResource, key)) {
            // @ts-ignore
            if (ClientCompanyWizardStepStateResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClientCompanyWizardStepStateResourceFromJSON(json: any): ClientCompanyWizardStepStateResource {
    return ClientCompanyWizardStepStateResourceFromJSONTyped(json, false);
}

export function ClientCompanyWizardStepStateResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyWizardStepStateResource {
    return json as ClientCompanyWizardStepStateResource;
}

export function ClientCompanyWizardStepStateResourceToJSON(value?: ClientCompanyWizardStepStateResource | null): any {
    return value as any;
}

